import { Button, Classes, Dialog } from '@blueprintjs/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface DocumentUploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpload: () => void;
  onUploadConfidential: () => void;
  showConfidential?: boolean;
}

const DocumentUploadModal = ({
  isOpen,
  onClose,
  onUpload,
  onUploadConfidential,
  showConfidential = true,
}: DocumentUploadModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      autoFocus
      canEscapeKeyClose
      canOutsideClickClose
      enforceFocus
      usePortal
      onClose={onClose}
      title={t('Upload Document')}
      isOpen={isOpen}
    >
      <div className={Classes.DIALOG_BODY}>
        <p>{t('Please select an upload option:')}</p>
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          {showConfidential && (
            <Button
              intent="danger"
              icon={<FontAwesomeIcon icon={['far', 'user-secret']} />}
              onClick={() => {
                onUploadConfidential();
                onClose();
              }}
            >
              {t('Upload Confidential')}
            </Button>
          )}
          <Button
            intent="primary"
            icon={<FontAwesomeIcon icon={['far', 'upload']} />}
            onClick={() => {
              onUpload();
              onClose();
            }}
          >
            {t('Upload')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default DocumentUploadModal;

